import Promise from 'bluebird';
import { fromJS, OrderedMap } from 'immutable';
import StoreConstants from '../constants/StoreConstants';
import StoreStore from '../stores/StoreStore';
import Store from '../models/Store';
import StoreFeed from '../models/StoreFeed';

const StoreActions = {
  fetch(context, payload) {
    if(payload.id) {
      context.dispatch(StoreConstants.FETCH_STORE_START, payload.id);
      context.dispatch(StoreConstants.SET_CURRENT_STORE, payload.id);
    }

    return context
      .delectoryApi
      .stores
      .store(payload)
      .then(responsePayload => {
        let store = new Store(responsePayload.store);

        if(payload.slug) {
          if(store.slug !== payload.slug) {
            let error = new Error('Redirect');
            error.statusCode = 302;
            error.location = store.url;
            throw error;
          }
          context.dispatch(StoreConstants.SET_CURRENT_STORE, store.id);
        }
        context.dispatch(StoreConstants.FETCH_STORE_SUCCESS, store);
        return store;
      })
      .catch(error => {
        context.dispatch(StoreConstants.FETCH_STORE_FAILURE, {error});
        if(error.code === 2000) {
          error.statusCode = 404;
        } else if(error.code === 2300) {
          // Store is inactive
          error.statusCode = 302;
          error.location = '/';
        }
        return Promise.reject(error);
      });
  },

  list(context, payload) {
    payload.pagination = payload.pagination || StoreStore.defaultPagination;
    payload.sorter = payload.sorter || StoreStore.defaultSorter;
    payload.filters = payload.filters || [];

    let requestPayload = {
      filters: payload.filters,
      pagination: payload.pagination,
      sort: [payload.sorter]
    };

    context.dispatch(StoreConstants.LIST_STORES_START, payload);

    return context
      .delectoryApi
      .stores
      .list(requestPayload)
      .then(responsePayload => {
        let stores = responsePayload.stores.reduce((map, store) => {
          return map.set(store.id, new Store(store));
        }, new OrderedMap());
        payload.pagination.totalResults = responsePayload.total_results;
        context.dispatch(StoreConstants.LIST_STORES_SUCCESS, {
          entities: stores,
          filters: payload.filters,
          pagination: payload.pagination,
          sorter: payload.sorter
        });
      })
      .catch(error => {
        context.dispatch(StoreConstants.LIST_STORES_FAILURE, {error});
      });
  },

  fetchFeed(context, payload) {
    let slug = payload.slug;
    context.dispatch(StoreConstants.FETCH_STORE_FEED_START, {slug});
    return context
      .delectoryApi
      .stores
      .feed({
        slug: slug,
        pagination: {offset: 0, limit: 10}
      })
      .then(responsePayload => {
        let storeFeed = new StoreFeed({items: responsePayload.items});
        context.dispatch(StoreConstants.FETCH_STORE_FEED_SUCCESS, {slug, storeFeed});
      })
      .catch(error => {
        context.dispatch(StoreConstants.FETCH_STORE_FEED_FAILURE, {error, slug});
      });
  }
};

export default StoreActions;



// WEBPACK FOOTER //
// banquet/actions/StoreActions.js